import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import BlogPage from "./components/BlogPage";
import BlogPostPage from "./components/BlogPostPage";
import RealtorListPage from "./components/RealtorListPage";
import RealtorDetailPage from "./components/RealtorDetailPage";
import RealtorAuthPage from "./components/RealtorAuthPage";
import RealtorDashboard from "./components/RealtorDashboard";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Protected route component for authenticated realtors
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0f1c] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#3b82f6]"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/realtor/auth" replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/realtor" element={<RealtorListPage />} />
      <Route path="/realtor/auth" element={<RealtorAuthPage />} />
      {/* Email verification and password reset routes */}
      <Route path="/verify-email" element={<RealtorAuthPage initialMode="verify" />} />
      <Route path="/reset-password" element={<RealtorAuthPage initialMode="reset-password" />} />
      <Route
        path="/realtor/dashboard"
        element={
          <ProtectedRoute>
            <RealtorDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/realtor/:slug" element={<RealtorDetailPage />} />
    </Routes>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-50 transition-colors duration-300">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
